import defaultSettings from 'settings';
const { storage, privateTokenKey, saasTokenKey, publicKey } = defaultSettings;

/**
 * @description 获取 iframe 中 url 参数
 * @param token
 */
export function getRequest() {
    let url = location.search;
    let theRequest = new Object();
    let strs;
    if (url.indexOf('?') != -1) {
        let str = url.substr(1);
        strs = str.split('&');
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
        }
    }
    return theRequest;
}
if (getRequest().TOKEN) {
    sessionStorage.setItem('TOKEN', getRequest().TOKEN);
    localStorage.setItem('TOKEN', getRequest().TOKEN);
    console.log(sessionStorage.getItem('TOKEN'), '测试token获取');
}
/**
 * @description 获取accessToken
 */
export function getAccessToken() {
    if (storage) {
        if ('localStorage' === storage) {
            return sessionStorage.getItem(privateTokenKey);
        } else if ('sessionStorage' === storage) {
            return sessionStorage.getItem(privateTokenKey);
        } else {
            return sessionStorage.getItem(privateTokenKey);
        }
    } else {
        return sessionStorage.getItem(privateTokenKey);
    }
}

/**
 * @description 存储accessToken
 * @param accessToken
 * @returns {void|*}
 */
export function setAccessToken(accessToken) {
    if (storage) {
        if ('localStorage' === storage) {
            return sessionStorage.setItem(privateTokenKey, accessToken);
        } else if ('sessionStorage' === storage) {
            return sessionStorage.setItem(privateTokenKey, accessToken);
        } else {
            return sessionStorage.setItem(privateTokenKey, accessToken);
        }
    } else {
        return sessionStorage.setItem(privateTokenKey, accessToken);
    }
}

/**
 * @description 移除accessToken
 * @returns {void|Promise<void>}
 */
export function removeAccessToken() {
    if (storage) {
        if ('localStorage' === storage) {
            return sessionStorage.removeItem(privateTokenKey);
        } else if ('sessionStorage' === storage) {
            return sessionStorage.clear();
        } else {
            return sessionStorage.removeItem(privateTokenKey);
        }
    } else {
        return sessionStorage.removeItem(privateTokenKey);
    }
}

/**
 * 获取accessInstance
 * @returns {string|ActiveX.IXMLDOMNode|Promise<any>|any|IDBRequest<any>|MediaKeyStatus|FormDataEntryValue|Function|Promise<Credential | null>}
 */
export function getAccessInstance() {
    if (storage) {
        if ('localStorage' === storage) {
            return sessionStorage.getItem(saasTokenKey);
        } else if ('sessionStorage' === storage) {
            return sessionStorage.getItem(saasTokenKey);
        } else {
            return sessionStorage.getItem(saasTokenKey);
        }
    } else {
        return sessionStorage.getItem(saasTokenKey);
    }
}

/**
 * @description 存储accessInstance
 * @param accessInstance
 * @returns {void|*}
 */
export function setAccessInstance(accessToken) {
    if (storage) {
        if ('localStorage' === storage) {
            return sessionStorage.setItem(saasTokenKey, accessToken);
        } else if ('sessionStorage' === storage) {
            return sessionStorage.setItem(saasTokenKey, accessToken);
        } else {
            return sessionStorage.setItem(saasTokenKey, accessToken);
        }
    } else {
        return sessionStorage.setItem(saasTokenKey, accessToken);
    }
}

/**
 * @description 移除accessInstance
 * @returns {void|Promise<void>}
 */
export function removeAccessInstance() {
    if (storage) {
        if ('localStorage' === storage) {
            return sessionStorage.removeItem(saasTokenKey);
        } else if ('sessionStorage' === storage) {
            return sessionStorage.clear();
        } else {
            return sessionStorage.removeItem(saasTokenKey);
        }
    } else {
        return sessionStorage.removeItem(saasTokenKey);
    }
}
function isJSON(str) {
    // console.log(str);
    if (typeof str == 'string') {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            console.log(e);
            return false;
        }
    }
    // console.log('It is not a string!');
}
/**
 * @description 获取
 */
export function get(key) {
    let value;
    if (storage) {
        if ('localStorage' === storage) {
            value = sessionStorage.getItem(publicKey + key);
        } else if ('sessionStorage' === storage) {
            value = sessionStorage.getItem(publicKey + key);
        } else {
            value = sessionStorage.getItem(publicKey + key);
        }
    } else {
        value = sessionStorage.getItem(publicKey + key);
    }
    return isJSON(value) ? JSON.parse(value) : value;
}

/**
 * @description 存储
 * @param accessToken
 * @returns {void|*}
 */
export function set(key, value) {
    if (typeof value === 'object' || Array.isArray(value)) {
        // 是数组 JSON.parse(JSON.stringify([1,2,3,4]))
        value = JSON.stringify(value);
    } else if (value && (value === 'true' || value === 'false')) {
        value = value === 'true' ? true : false;
    } else if (typeof value === 'string' && typeof value === 'number') {
        // 不是字符串 也不是数字
        throw TypeError('输入数据类型必须是[array, object, string, number]');
    }
    if (storage) {
        if ('localStorage' === storage) {
            return sessionStorage.setItem(publicKey + key, value);
        } else if ('sessionStorage' === storage) {
            return sessionStorage.setItem(publicKey + key, value);
        } else {
            return sessionStorage.setItem(publicKey + key, value);
        }
    } else {
        return sessionStorage.setItem(publicKey + key, value);
    }
}

/**
 * @description 移除
 * @returns {void|Promise<void>}
 */
export function remove(key) {
    if (storage) {
        if ('localStorage' === storage) {
            return sessionStorage.removeItem(publicKey + key);
        } else if ('sessionStorage' === storage) {
            return sessionStorage.clear();
        } else {
            return sessionStorage.removeItem(publicKey + key);
        }
    } else {
        return sessionStorage.removeItem(publicKey + key);
    }
}
